import { createContext } from 'react';
import { APIError } from '../../services/api';
import { Channels, TSite, TMenu } from '../site/site-context';

/**************************
 *
 * Delivery venues
 *
 **************************/

export interface DeliveryVenues {
    data: TDeliveryVenue[];
    errors: APIError;
    event_id: number;
    flow: string;
}

export interface TDeliveryVenue {
    uid: string;
    name: string;
    address_1: string;
    address_2: string | null;
    address_city: string;
    address_postcode: string;
    instructions: string;
    channels: Channels;
    site: TSite;
}

export type DeliveryVenueContextData = {
    site: TSite | null;
    menu: TMenu | null;

    fetchDeliveryVenue: (
        id: string,
        flow?: string,
    ) => void;

    deliveryVenues: TDeliveryVenue[] | null;
    fetchDeliveryVenues: (handle: string, flow: string) => void;

    loading: boolean;
    setLoading: (state: boolean) => void;

    flow: string;
    setFlow: (flow: string) => void;
};

export const DeliveryVenueContext = createContext<DeliveryVenueContextData>({
    site: null,
    menu: null,

    fetchDeliveryVenue: () => {},

    deliveryVenues: null,
    fetchDeliveryVenues: () => {},

    loading: false,
    setLoading: () => {},

    flow: 'noflow',
    setFlow: () => {},
});
